module.exports = __webpack_public_path__ + "static/media/3.ccd97ffd.jpg";